import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./state/auth/AuthContext.jsx";
import { SocketProvider } from "./context/SocketContext.jsx";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <Routes />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
